@if (loading()) {
<section class="comunidad comunidad--skeleton" aria-label="Cargando comunidad" aria-busy="true">
  <div class="comunidad__inner">
    <header class="comunidad__header" aria-hidden="true">
      <span class="comunidad-skeleton__line comunidad-skeleton__line--title"></span>
      <span class="comunidad-skeleton__line comunidad-skeleton__line--subtitle"></span>
    </header>
    <div class="comunidad-skeleton__hero" aria-hidden="true"></div>
    <div class="comunidad-skeleton__channels" aria-hidden="true">
      @for (channel of [0, 1, 2, 3]; track channel) {
        <span class="comunidad-skeleton__channel"></span>
      }
    </div>
  </div>
</section>
} @else if (vm(); as m) {
<section class="comunidad">
  <div class="comunidad__inner">
    <header class="comunidad__header">
      <h2 class="comunidad__title">{{ m.sectionTitle }}</h2>
      <p class="comunidad__subtitle">{{ m.subtitle }}</p>
    </header>

    <!-- Zona A: WhatsApp destacado -->
    @if (m.whatsapp.link; as link) {
    <a
      [href]="link"
      class="comunidad-hero"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Grupo de WhatsApp de Perrón Store"
    >
      <div class="comunidad-hero__content">
        <div class="comunidad-hero__icon-wrap">
          <app-icon [icon]="whatsappIcon" [size]="32" />
        </div>
        <h3 class="comunidad-hero__title">{{ m.whatsapp.title }}</h3>
        <p class="comunidad-hero__desc">{{ m.whatsapp.description }}</p>
        <span class="comunidad-hero__cta">{{ m.whatsapp.cta }}</span>
      </div>
      @if (!mascotError()) {
        <div class="comunidad-hero__mascot">
          <img
            src="images/logo/comunity.png"
            alt=""
            width="450"
            height="512"
            loading="lazy"
            class="comunidad-hero__mascot-img"
            (error)="onMascotError()"
          />
        </div>
      }
    </a>
    }

    <!-- Zona B: Resto de redes -->
    <div class="comunidad-channels">
      <!-- Instagram -->
      <a
        [href]="m.instagram.url"
        class="comunidad-channel comunidad-channel--instagram"
        [attr.target]="isExternalLink(m.instagram.url) ? '_blank' : null"
        [attr.rel]="isExternalLink(m.instagram.url) ? 'noopener noreferrer' : null"
        [attr.aria-label]="m.instagram.title"
        (click)="onChannelClick($event, m.instagram.url)"
      >
        <div class="comunidad-channel__icon-wrap">
          <app-icon [icon]="instagramIcon" [size]="24" />
        </div>
        <div class="comunidad-channel__body">
          <span class="comunidad-channel__name">{{ m.instagram.title }}</span>
          <span class="comunidad-channel__desc">{{ m.instagram.description }}</span>
        </div>
        <span class="comunidad-channel__cta">{{ m.instagram.button_label }}</span>
      </a>

      <!-- Facebook -->
      <a
        [href]="m.facebook.url"
        class="comunidad-channel comunidad-channel--facebook"
        [attr.target]="isExternalLink(m.facebook.url) ? '_blank' : null"
        [attr.rel]="isExternalLink(m.facebook.url) ? 'noopener noreferrer' : null"
        [attr.aria-label]="m.facebook.title"
        (click)="onChannelClick($event, m.facebook.url)"
      >
        <div class="comunidad-channel__icon-wrap">
          <app-icon [icon]="facebookIcon" [size]="24" />
        </div>
        <div class="comunidad-channel__body">
          <span class="comunidad-channel__name">{{ m.facebook.title }}</span>
          <span class="comunidad-channel__desc">{{ m.facebook.description }}</span>
        </div>
        <span class="comunidad-channel__cta">{{ m.facebook.button_label }}</span>
      </a>

      <!-- TikTok -->
      <a
        [href]="m.tiktok.url"
        class="comunidad-channel comunidad-channel--tiktok"
        [attr.target]="isExternalLink(m.tiktok.url) ? '_blank' : null"
        [attr.rel]="isExternalLink(m.tiktok.url) ? 'noopener noreferrer' : null"
        [attr.aria-label]="m.tiktok.title"
        (click)="onChannelClick($event, m.tiktok.url)"
      >
        <div class="comunidad-channel__icon-wrap">
          <!-- TODO: replace with TikTok SVG icon — Music2 is a placeholder -->
          <app-icon [icon]="tiktokIcon" [size]="24" />
        </div>
        <div class="comunidad-channel__body">
          <span class="comunidad-channel__name">{{ m.tiktok.title }}</span>
          <span class="comunidad-channel__desc">{{ m.tiktok.description }}</span>
        </div>
        <span class="comunidad-channel__cta">{{ m.tiktok.button_label }}</span>
      </a>

      <!-- Comunidad Perrón — clicable solo si hay enlace -->
      @if (m.community.url; as communityLink) {
      <a
        [href]="communityLink"
        class="comunidad-channel comunidad-channel--community"
        [attr.target]="isExternalLink(communityLink) ? '_blank' : null"
        [attr.rel]="isExternalLink(communityLink) ? 'noopener noreferrer' : null"
        [attr.aria-label]="m.community.title"
        (click)="onChannelClick($event, communityLink)"
      >
        <div class="comunidad-channel__icon-wrap">
          <app-icon [icon]="communityIcon" [size]="24" />
        </div>
        <div class="comunidad-channel__body">
          <div class="comunidad-channel__name-row">
            <span class="comunidad-channel__name">{{ m.community.title }}</span>
            @if (m.community.badge) {
              <span class="badge-soon">{{ m.community.badge }}</span>
            }
          </div>
          <span class="comunidad-channel__desc">{{ m.community.description }}</span>
        </div>
      </a>
      } @else {
      <div
        class="comunidad-channel comunidad-channel--community"
        [attr.aria-label]="m.community.title + ' — ' + m.community.badge"
      >
        <div class="comunidad-channel__icon-wrap">
          <app-icon [icon]="communityIcon" [size]="24" />
        </div>
        <div class="comunidad-channel__body">
          <div class="comunidad-channel__name-row">
            <span class="comunidad-channel__name">{{ m.community.title }}</span>
            @if (m.community.badge) {
              <span class="badge-soon">{{ m.community.badge }}</span>
            }
          </div>
          <span class="comunidad-channel__desc">{{ m.community.description }}</span>
        </div>
      </div>
      }
    </div>
  </div>
</section>
}
